import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import LeadForm from "@/components/LeadForm";
import { BRAND } from "@/lib/brand";
import { Phone, MessageSquare, Clock, ShieldCheck, Mail } from "lucide-react";

export default function Contact() {
  return (
    <>
      <Seo path="/contact" title="Get My Free Quote" description="Request a free junk removal quote from Skedaddle. Tell us what needs to go and we will get right back to you. Serving the Lowcountry, SC." />
      <PageHero eyebrow="Get a quote" title="Tell us what needs to go!" subtitle="Free quotes, no pressure. Fill this out or just text us a photo. One call and it skedaddles!" />

      <section className="bg-white py-14 md:py-20">
        <div className="mx-auto max-w-5xl px-4 md:px-8 grid lg:grid-cols-[1.4fr,1fr] gap-10">
          <div className="bg-cream border-2 border-charcoal rounded-[2rem] shadow-brutlg p-6 md:p-8">
            <h2 className="font-heading font-bold text-2xl mb-4">Get My Free Quote</h2>
            <LeadForm />
          </div>
          <div className="space-y-4">
            <a href={BRAND.phoneHref} className="flex items-center gap-4 bg-coral text-cream border-2 border-charcoal rounded-3xl p-6 shadow-brut" data-testid="contact-call">
              <Phone className="w-8 h-8" /><div><div className="font-heading font-bold text-xl">Call us</div><div className="font-body">{BRAND.phoneDisplay}</div></div>
            </a>
            <a href={BRAND.smsHref} className="flex items-center gap-4 bg-teal text-cream border-2 border-charcoal rounded-3xl p-6 shadow-brut" data-testid="contact-text">
              <MessageSquare className="w-8 h-8" /><div><div className="font-heading font-bold text-xl">Text us</div><div className="font-body">Send a photo, get a quote!</div></div>
            </a>
            <a href={BRAND.emailHref} className="flex items-center gap-4 bg-white border-2 border-charcoal rounded-3xl p-6 shadow-brut" data-testid="contact-email">
              <Mail className="w-8 h-8 text-teal" /><div><div className="font-heading font-bold text-xl">Email us</div><div className="font-body break-all">{BRAND.email}</div></div>
            </a>
            <div className="bg-white border-2 border-charcoal rounded-3xl p-6 shadow-brut space-y-3">
              <div className="flex items-center gap-3 font-body"><Clock className="w-5 h-5 text-teal" /> {BRAND.hours}</div>
              <div className="flex items-center gap-3 font-body"><ShieldCheck className="w-5 h-5 text-teal" /> Free quotes, no pressure</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
